import { get2 } from "@/shared/axios";
import { Branch } from "@/shared/utils/interfaces";
import { useQuery } from "@tanstack/react-query";

const useWebsiteSettingsQuery = (site: string) => {
  const queryFn = ["website-settings", site];
  const query = useQuery<{
    branches: Branch[];
  }>({
    queryKey: queryFn,
    enabled: site !== "",
    queryFn: () =>
      get2(
        `/internal/anonymous/websites/v3/hostname/settings/parameter/${site}/`
      ),
  });

  return query;
};

export default useWebsiteSettingsQuery;
